
var id = "chart";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1205 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chart\"><path d=\"M1189.611371 1024 1084.202768 1024 783.035333 1024 722.801845 1024 481.867897 1024 421.63441 1024 120.466974 1024 15.058372 1024C6.746151 1024 0 1017.253849 0 1008.941628L0 978.824884C0 970.512664 6.746151 963.766513 15.058372 963.766513L120.466974 963.766513 120.466974 421.635012C120.466974 388.386127 147.421459 361.401525 180.700461 361.401525L421.63441 361.401525 421.63441 240.964667C421.63441 207.685665 448.588895 180.73118 481.867897 180.73118L722.801845 180.73118 722.801845 60.234089C722.801845 26.985204 749.756331 0.000602 783.035333 0.000602L1023.969281 0.000602C1057.218165 0.000602 1084.202768 26.985204 1084.202768 60.234089L1084.202768 963.766513 1189.611371 963.766513C1197.923591 963.766513 1204.669742 970.512664 1204.669742 978.824884L1204.669742 1008.941628C1204.669742 1017.253849 1197.923591 1024 1189.611371 1024ZM421.63441 421.635012 180.700461 421.635012 180.700461 963.766513 421.63441 963.766513 421.63441 421.635012ZM722.801845 240.934551 481.867897 240.934551 481.867897 963.766513 722.801845 963.766513 722.801845 240.934551ZM1023.969281 60.264206 783.035333 60.264206 783.035333 963.766513 1023.969281 963.766513 1023.969281 60.264206Z\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
